import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { GetInvestigationFieldValuesQuery } from './get-investigation-field-values.query';
import { GetInvestigationFieldValuesResult } from './get-investigation-field-values.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationFieldValuesUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationFieldValuesQuery): Observable<GetInvestigationFieldValuesResult> {
    this._state.setLoadingFieldValues(true);
    this._state.setErrorFieldValues(null);

    return this._repository.getFieldValues(query.investigationId).pipe(
      tap((fieldValues) => {
        this._state.setFieldValues(fieldValues);
        this._state.setLoadingFieldValues(false);
      }),
      map((fieldValues) => ({ fieldValues })),
      catchError((error) => {
        this._state.setErrorFieldValues(error.message || 'Failed to get field values');
        this._state.setLoadingFieldValues(false);
        return throwError(() => error);
      }),
    );
  }
}
